import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { createForm } from 'rc-form';
import {
    Grid,
    Typography,
    Button,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    IconButton,
    FormHelperText,
} from '@material-ui/core';
import CancelPresentation from '@material-ui/icons/CancelPresentation';

import { generateGuide } from 'Console/data/applicationDetail/settings/SettingsAction';

import FormInput from 'Console/components/common/form/FormInput';
import FormSelect from 'Console/components/common/form/FormSelect';

import {
    ID_TYPE_OPTIONS,
    PRESETS_OPTIONS,
    MODEL_TYPE_OPTIONS,
    SEQUENCE_MINER_OPTIONS,
    DAY_SPLIT,
    SEQUENCE_MINER_DAY_SESSIONS,
    BREAK_SPLIT,
    SEQUENCE_MINER_SESSIONS,
    SEQUENCE_SPLIT,
    SEQUENCE_MINER_TIME_SESSIONS,
    CUSTOM_PRESET,
    ID_TYPE_VISITOR_ID,
    MODEL_TYPE_WORKDAY,
    SEQUENCE_MINER,
    MODEL_SIMILARITY_BASED,
    SEQUENCE_MINER_DERIVED_TIME_SESSIONS,
} from 'Console/constants/appConstants';
import { validateUrlAddress } from 'Console/utils/formUtils';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        alignItems: 'center',
        padding: '0 24px',
        fontSize: theme.typography.pxToRem(14),
    },
    title: {
        display: 'inline-block',
        fontWeight: 'bold',
        paddingBottom: theme.typography.pxToRem(20),
    },
    message: {
        fontSize: theme.typography.pxToRem(14),
        paddingBottom: theme.typography.pxToRem(34),
    },
    btn: {
        marginBottom: theme.typography.pxToRem(65),
    },
    btnAdd: {
        marginTop: theme.spacing.unit + 7,
        marginLeft: theme.spacing.unit * 5 + 7,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
        },
    },
    listItem: {
        padding: 0,
    },
    boxList: {
        width: '45%',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    formInput: {
        width: '33%',
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '100%',
        },
    },
    formInput2: {
        width: '49%',
        '&:nth-of-type(1)': {
            paddingRight: 20,
        },
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '100%',
            '&:nth-of-type(1)': {
                paddingRight: 0,
                paddingBottom: 20,
            },
        },
    },
    itemsBox: {
        paddingTop: theme.typography.pxToRem(22),
        paddingBottom: theme.typography.pxToRem(32),
        display: 'flex',
        flexDirection: 'row',
        width: '33.7%',
        '&:nth-of-type(1n)': {
            paddingBottom: theme.typography.pxToRem(20),
            paddingTop: 0,
        },
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
    },
    input: {
        'padding-top': theme.typography.pxToRem(10),
    },
    input2: {
        'padding-top': theme.typography.pxToRem(20),
    },
    helperDisplayNone: {
        display: 'none',
    },
});

class GuideGeneration extends Component {
    handleGenerateGuide = () => {
        const {
            form: { getFieldsValue, resetFields },
            generateGuide,
            intl,
        } = this.props;

        const {
            idType,
            arrayIds,
            arrayUrls,
            minNumOfExperts,
            maxNumOfGuides,
            modelType,
            preset,
            maxStepsInSequence,
            timeThreshold,
            sequenceMiner,
        } = getFieldsValue([
            'idType',
            'arrayIds',
            'arrayUrls',
            'minNumOfExperts',
            'maxNumOfGuides',
            'modelType',
            'preset',
            'maxStepsInSequence',
            'timeThreshold',
            'sequenceMiner',
        ]);

        const result = {
            idType: idType.value,
            expertIds: arrayIds,
            urls: arrayUrls,
            minimalSupport: parseInt(minNumOfExperts, 10),
            count: parseInt(maxNumOfGuides, 10),
            modelType: modelType.value,
            presetSelect: preset.value,
        };

        switch (preset.value) {
            case DAY_SPLIT:
                generateGuide(
                    {
                        ...result,
                        config: {
                            processMiningConfiguration: {
                                sequenceMiner: SEQUENCE_MINER_DAY_SESSIONS,
                            },
                        },
                    },
                    {
                        success: (
                            <FormattedMessage
                                id="Notification.generation.guide.success"
                                defaultMessage="Guide generation started, check guides in the space later"
                            />
                        ),

                        fail: (
                            <FormattedMessage
                                id="Notification.generation.guide.fail"
                                defaultMessage="Guide generation failed"
                            />
                        ),
                    }
                );

                break;
            case BREAK_SPLIT:
                generateGuide(
                    {
                        ...result,
                        maximalEventsInSession: 20,
                        maximalTimeBetweenEvents: 20,
                        config: {
                            processMiningConfiguration: {
                                sequenceMiner: SEQUENCE_MINER_SESSIONS,
                            },
                        },
                    },
                    {
                        success: (
                            <FormattedMessage
                                id="Notification.generation.guide.success"
                                defaultMessage="Guide generation started, check guides in the space later"
                            />
                        ),

                        fail: (
                            <FormattedMessage
                                id="Notification.generation.guide.fail"
                                defaultMessage="Guide generation failed"
                            />
                        ),
                    }
                );

                break;

            case SEQUENCE_SPLIT:
                generateGuide(
                    {
                        ...result,
                        maximalEventsInSession: -1,
                        maximalTimeBetweenEvents: 30,
                        config: {
                            processMiningConfiguration: {
                                sequenceMiner: SEQUENCE_MINER_TIME_SESSIONS,
                            },
                        },
                    },
                    {
                        success: (
                            <FormattedMessage
                                id="Notification.generation.guide.success"
                                defaultMessage="Guide generation started, check guides in the space later"
                            />
                        ),

                        fail: (
                            <FormattedMessage
                                id="Notification.generation.guide.fail"
                                defaultMessage="Guide generation failed"
                            />
                        ),
                    }
                );
                break;

            case CUSTOM_PRESET:
                generateGuide(
                    {
                        ...result,
                        maximalEventsInSession: parseInt(maxStepsInSequence, 10),
                        maximalTimeBetweenEvents: parseInt(timeThreshold, 10),
                        config: {
                            processMiningConfiguration: {
                                sequenceMiner: sequenceMiner.value,
                            },
                        },
                    },
                    {
                        success: (
                            <FormattedMessage
                                id="Notification.generation.guide.success"
                                defaultMessage="Guide generation started, check guides in the space later"
                            />
                        ),

                        fail: (
                            <FormattedMessage
                                id="Notification.generation.guide.fail"
                                defaultMessage="Guide generation failed"
                            />
                        ),
                    }
                );
                break;

            default:
                generateGuide(
                    {
                        idType: ID_TYPE_VISITOR_ID,
                        expertIds: '',
                        urls: '',
                        minimalSupport: 1,
                        count: 1,
                        modelType: MODEL_TYPE_WORKDAY,
                        maximalEventsInSession: 5,
                        maximalTimeBetweenEvents: 28800,
                        presetSelect: DAY_SPLIT,
                    },
                    {
                        success: `${intl.formatMessage({
                            id: 'Notification.generation.guide.success',
                        })}`,
                        fail: `${intl.formatMessage({ id: 'Notification.generation.guide.fail' })}`,
                    }
                );
        }

        resetFields([
            'idType',
            'arrayIds',
            'arrayUrls',
            'minNumOfExperts',
            'maxNumOfGuides',
            'modelType',
            'preset',
            'timeThreshold',
            'sequenceMiner',
            'maxStepsInSequence',
        ]);
    };

    handleAddId = () => {
        const {
            form: { getFieldValue, setFieldsValue },
        } = this.props;
        const id = getFieldValue('id');
        const arrayIds = getFieldValue('arrayIds');

        setFieldsValue({
            arrayIds: [...arrayIds, id],
            id: '',
        });
    };

    handleRemoveId = (row) => {
        const {
            form: { getFieldValue, setFieldsValue },
        } = this.props;
        const arrayIds = getFieldValue('arrayIds');

        setFieldsValue({
            arrayIds: arrayIds.filter((item) => item !== row),
        });
    };

    handleAddUrl = () => {
        const {
            form: { getFieldValue, setFieldsValue },
        } = this.props;

        const prefixUrl = (url = '') => {
            if (url.indexOf('http') === -1) {
                return `https://${url}`;
            }

            return url;
        };
        const url = prefixUrl(getFieldValue('url'));
        const arrayUrls = getFieldValue('arrayUrls');

        setFieldsValue({
            arrayUrls: [...arrayUrls, url],
            url: '',
        });
    };

    handleRemoveUrl = (row) => {
        const {
            form: { getFieldValue, setFieldsValue },
        } = this.props;
        const arrayUrls = getFieldValue('arrayUrls');

        setFieldsValue({
            arrayUrls: arrayUrls.filter((item) => item !== row),
        });
    };

    render() {
        const {
            classes,
            intl,
            form,
            form: { getFieldDecorator, getFieldValue },
        } = this.props;

        getFieldDecorator('arrayIds', {
            initialValue: [],
            preserve: true,
        });

        getFieldDecorator('arrayUrls', {
            initialValue: [],
            preserve: true,
        });

        const isEGGv3ModelSelected =
            getFieldValue('modelType') !==
            MODEL_TYPE_OPTIONS.find((modelType) => modelType.value === MODEL_SIMILARITY_BASED);

        const isTimeThresholdDisabled =
            getFieldValue('sequenceMiner') ===
            SEQUENCE_MINER_OPTIONS.find((sequenceMiner) => sequenceMiner.value === SEQUENCE_MINER);

        const isMaxStepsInSequenceDisabled = () => {
            const sequenceMinerKeysWithoutSteps = [
                SEQUENCE_MINER,
                SEQUENCE_MINER_TIME_SESSIONS,
                SEQUENCE_MINER_DERIVED_TIME_SESSIONS,
            ];
            const sequenceMinersWithoutSteps = SEQUENCE_MINER_OPTIONS.filter((sequenceMiner) =>
                sequenceMinerKeysWithoutSteps.includes(sequenceMiner.value)
            );
            return sequenceMinersWithoutSteps.includes(getFieldValue('sequenceMiner'));
        };

        return (
            <>
                <Grid item>
                    <Typography variant="subtitle1" className={classes.title}>
                        <FormattedMessage
                            id="Settings.confusion.guideGeneration.title"
                            defaultMessage="Guide generation based on user's behavior"
                        />
                    </Typography>
                </Grid>

                <Grid className={classes.formInput} style={{ marginBottom: 20 }}>
                    <FormSelect
                        form={form}
                        fullWidth={false}
                        isRequired
                        label={intl.formatMessage({
                            id: 'Settings.confusion.guideGeneration.idType.label',
                        })}
                        formItemKey="idType"
                        optionList={ID_TYPE_OPTIONS}
                        initialValue={ID_TYPE_OPTIONS.find(
                            (idType) => idType.value === ID_TYPE_VISITOR_ID
                        )}
                    />
                </Grid>

                <>
                    <Grid container direction="row" alignItems="flex-end">
                        <Grid className={classes.formInput}>
                            <FormInput
                                fullWidth={false}
                                form={form}
                                isRequired
                                type="text"
                                formItemKey="id"
                                placeholder={intl.formatMessage({
                                    id: 'Settings.confusion.guideGeneration.ids.floatingLabelText',
                                })}
                            />
                        </Grid>

                        <Typography variant="button">
                            <Button
                                id="yeself-button"
                                variant="contained"
                                color="primary"
                                onClick={this.handleAddId}
                                className={classes.btnAdd}
                                disabled={!getFieldValue('id')}
                            >
                                <FormattedMessage id="Buttons.add" defaultMessage="Add" />
                            </Button>
                        </Typography>
                    </Grid>

                    <Grid item className={classes.boxList}>
                        <List className={classes.listItems}>
                            {getFieldValue('arrayIds').map((item) => (
                                <ListItem className={classes.listItem} key={item}>
                                    <ListItemText primary={item} value={item} />
                                    <ListItemIcon>
                                        <IconButton
                                            aria-label="Delete"
                                            onClick={() => this.handleRemoveId(item)}
                                        >
                                            <CancelPresentation />
                                        </IconButton>
                                    </ListItemIcon>
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                </>

                <>
                    <Grid container direction="row" alignItems="flex-end">
                        <Grid className={classes.formInput}>
                            <FormInput
                                fullWidth={false}
                                form={form}
                                isRequired
                                type="text"
                                formItemKey="url"
                                placeholder={intl.formatMessage({
                                    id: 'Settings.confusion.guideGeneration.urls.floatingLabelText',
                                })}
                                additionalRules={[
                                    {
                                        validator: validateUrlAddress,
                                    },
                                ]}
                            />
                        </Grid>

                        <Typography variant="button">
                            <Button
                                id="yeself-button"
                                variant="contained"
                                color="primary"
                                onClick={this.handleAddUrl}
                                className={classes.btnAdd}
                                disabled={!getFieldValue('url')}
                            >
                                <FormattedMessage id="Buttons.add" defaultMessage="Add" />
                            </Button>
                        </Typography>
                    </Grid>

                    <Grid item className={classes.boxList}>
                        <List className={classes.listItems}>
                            {getFieldValue('arrayUrls').map((item) => (
                                <ListItem className={classes.listItem} key={item}>
                                    <ListItemText primary={item} value={item} />
                                    <ListItemIcon>
                                        <IconButton
                                            aria-label="Delete"
                                            onClick={() => this.handleRemoveUrl(item)}
                                        >
                                            <CancelPresentation />
                                        </IconButton>
                                    </ListItemIcon>
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                </>

                <Grid container direction="row" alignItems="flex-end" className={classes.itemsBox}>
                    <Grid className={classes.formInput2}>
                        <FormInput
                            form={form}
                            fullWidth
                            isRequired={false}
                            type="number"
                            classes={{ textField: classes.input }}
                            label={intl.formatMessage({
                                id:
                                    'Settings.confusion.guideGeneration.minNumOfExperts.floatingLabelText',
                            })}
                            formItemKey="minNumOfExperts"
                            initialValue={1}
                        />
                    </Grid>

                    <Grid className={classes.formInput2}>
                        <FormInput
                            form={form}
                            fullWidth
                            isRequired={false}
                            type="number"
                            classes={{ textField: classes.input }}
                            label={intl.formatMessage({
                                id:
                                    'Settings.confusion.guideGeneration.maxNumOfGuides.floatingLabelText',
                            })}
                            formItemKey="maxNumOfGuides"
                            initialValue={1}
                        />
                    </Grid>
                </Grid>

                <Grid className={classes.formInput} style={{ marginBottom: 20 }}>
                    <FormSelect
                        form={form}
                        fullWidth={false}
                        isRequired
                        label={intl.formatMessage({
                            id: 'Settings.confusion.guideGeneration.modelType.label',
                        })}
                        formItemKey="modelType"
                        optionList={MODEL_TYPE_OPTIONS}
                        initialValue={MODEL_TYPE_OPTIONS.find(
                            (modelType) => modelType.value === MODEL_TYPE_WORKDAY
                        )}
                    />
                    <FormHelperText className={isEGGv3ModelSelected ? null : classes.helperDisplayNone}>
                        {intl.formatMessage({ id: 'Settings.confusion.guideGeneration.EGGv3Control' })}
                    </FormHelperText>
                </Grid>

                <Grid className={classes.formInput} style={{ marginBottom: 20 }}>
                    <FormSelect
                        form={form}
                        fullWidth={false}
                        isRequired
                        label={intl.formatMessage({
                            id: 'Settings.confusion.guideGeneration.preset.label',
                        })}
                        formItemKey="preset"
                        optionList={PRESETS_OPTIONS}
                        initialValue={PRESETS_OPTIONS.find((preset) => preset.value === DAY_SPLIT)}
                    />
                </Grid>

                {getFieldValue('preset') && getFieldValue('preset').value === CUSTOM_PRESET && (
                    <>
                        <Grid className={classes.formInput} style={{ marginBottom: 20 }}>
                            <FormSelect
                                form={form}
                                fullWidth
                                isRequired
                                label={intl.formatMessage({
                                    id: 'Settings.confusion.guideGeneration.sequenceMiner.label',
                                })}
                                formItemKey="sequenceMiner"
                                optionList={SEQUENCE_MINER_OPTIONS}
                                initialValue={SEQUENCE_MINER_OPTIONS.find(
                                    (preset) => preset.value === SEQUENCE_MINER_SESSIONS
                                )}
                            />
                        </Grid>
                        <Grid
                            container
                            direction="row"
                            alignItems="flex-end"
                            className={classes.itemsBox}
                        >
                            <Grid className={classes.formInput2}>
                                <FormInput
                                    form={form}
                                    fullWidth
                                    isRequired
                                    type="number"
                                    classes={{ textField: classes.input2 }}
                                    disabled={isMaxStepsInSequenceDisabled()}
                                    label={intl.formatMessage({
                                        id:
                                            'Settings.confusion.guideGeneration.maxStepsInSequence.floatingLabelText',
                                    })}
                                    formItemKey="maxStepsInSequence"
                                    initialValue={-1}
                                />
                            </Grid>

                            <Grid className={classes.formInput2}>
                                <FormInput
                                    form={form}
                                    fullWidth
                                    isRequired
                                    type="number"
                                    classes={{ textField: classes.input2 }}
                                    disabled={isTimeThresholdDisabled}
                                    label={intl.formatMessage({
                                        id:
                                            'Settings.confusion.guideGeneration.timeThreshold.floatingLabelText',
                                    })}
                                    formItemKey="timeThreshold"
                                    initialValue={-1}
                                />
                            </Grid>
                        </Grid>
                    </>
                )}

                <Grid container alignItems="center">
                    <Typography variant="button">
                        <Button
                            id="yeself-button"
                            variant="contained"
                            color="primary"
                            onClick={this.handleGenerateGuide}
                            disabled={getFieldValue('arrayIds').length === 0}
                        >
                            <FormattedMessage id="Buttons.generate" defaultMessage="Generate" />
                        </Button>
                    </Typography>
                </Grid>
            </>
        );
    }
}

export default connect(null, {
    generateGuide,
})(withStyles(styles)(createForm()(injectIntl(GuideGeneration))));
